import { useEffect, useState } from 'react';

/** The current time, refreshed twice a minute — for clocks and «зараз» marks. */
export function useMinute() {
  const [now, setNow] = useState(() => Date.now());
  useEffect(() => {
    const id = setInterval(() => setNow(Date.now()), 30_000);
    return () => clearInterval(id);
  }, []);
  return now;
}
